<template>
  <ubi-panel>
    <div class="header-buttons">
      <div class="date">{{$t('planning.resultsOfTheDate')}} {{formattedDate}}</div>
      <div>
        <span class="forSelection" v-if="multipleSelection.length > 0">{{$t('planning.forSelection', { selectedNumber: multipleSelection.length } )}}</span>
        <el-button  v-if="multipleSelection.length > 0">
          <downloadexcel
              :data="exporter"
              type="xls"
              :name="nomFichierExport">
            {{$t('users.export')}}
          </downloadexcel>
        </el-button>
        <el-button @click="deletedSheduledTableCalendar" v-if="multipleSelection.length > 0">{{$t('general.calendar.delete')}}</el-button>
      </div>
    </div>
    <PaginationPage  :total="getDataBytab.length"
                     :currentPage.sync="currentPage"
                     :pageSize.sync="pageSize"
                     @update:currentPage="fetchPage"
                     @update:pageSize="fetchPageSize"/>
    <el-table
        ref="multipleTable"
        :data="currentEvents"
        style="width: 100%"
        v-loading="getLoading"
        @selection-change="handleSelectionChange"
    >
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column width="180" v-slot="{ row: event }" label="Photos">
        <div>
          <img v-if="event.picture"  :src="event.picture" :alt="event.name" width="100px" />
          <div v-else class="without-picture">
            <span class="mdi mdi-camera-off-outline"></span>
          </div>
        </div>
      </el-table-column>
      <el-table-column v-slot="{row: event}" :label="$t('planning.titleAds')" width="180">
        <template><span class="text-ellipsis">{{ event.titre }}</span></template>
      </el-table-column>
      <el-table-column v-slot="{ row: event }" :label="$t('planning.publishOn')" width="100">
        <v-icon class="mr-4" :style="{ color: event.color }">{{ event.icon }}</v-icon>
      </el-table-column>
      <el-table-column v-slot="{ row: event }" :label="$t('planning.date')" width="200">
        <template>{{ convertDate(event.start) }}</template>
      </el-table-column>
      <el-table-column v-slot="{ row: event }" :label="$t('planning.status')" width="120">
        <el-col>
          <el-tag :type="event.status === 'postPlanned' ? 'warning' : 'success'"
                  disable-transitions>{{ event.status === 'isCurrentlyPublished' || event.status === 'postPublished' ? 'Publié' : 'Planifié'}}</el-tag>
        </el-col>
      </el-table-column>
      <el-table-column :label="$t('general.calendar.edit')" v-slot="{ row: event }">
        <el-link type="danger" size="mini" @click="handleEdit(event)">
          <i class="el-icon-edit"></i>
        </el-link>
      </el-table-column>
    </el-table>
    <PaginationPage  :total="getDataBytab.length"
                     :currentPage.sync="currentPage"
                     :pageSize.sync="pageSize"
                     @update:currentPage="fetchPage"
                     @update:pageSize="fetchPageSize"/>
  </ubi-panel>
</template>

<script>
import { convertDate, convertDateWithOutTime } from '@/helpers/functions/convertDate'
import downloadexcel from 'vue-json-excel'
import PaginationPage from '@/components/ui/PaginationPage.vue'
import UbiPanel from '@/components/Panel.vue'
import { $t } from '@/i18n'

export default {
  name: 'TableDetailsCalendar',
  props: ['getDataBytab'],
  components: { UbiPanel, PaginationPage, downloadexcel },
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      multipleSelection: [],
      rowspanData: {},
      nomFichierExport: this.$t('planning.exportPlanning', { date: this.$route.params.date }) + '.xls'
    }
  },
  computed: {
    formattedDate () {
      return convertDateWithOutTime(new Date(this.$route.params.date))
    },
    getLoading () {
      return this.$store.getters['calendarSocialPosts/getIsLoadingStatus']
    },
    exporter () {
      return this.multipleSelection.map((event) => {
        return { annonce: event.annonces[0], reference: event.reference, status: event.status === 'isCurrentlyPublished' || event.status === 'postPublished' ? 'Publié' : 'Planifié', portails: event.portails[0].code }
      })
    },
    currentEvents () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.getDataBytab.slice(start, end)
    }
  },
  methods: {
    convertDate,
    handleCurrentChange (page) {
      this.currentPage = page
    },
    handleEdit (event) {
      const portails = event.portails[0].code
      if (portails.endsWith('_EDITO')) {
        this.$router.push(`/new_socialnetwork_post/edit-editorial/${event.annonces[0]}`)
      } else if (portails.endsWith('_BIENS_VENDUS')) {
        this.$router.push(`/posts/bien-vendu/${event.annonces[0]}/edit`)
      } else {
        this.$router.replace({
          path: `/posts/manage-posts/${event.annonces[0]}`,
          query: { network: portails.split('_')[0].toLowerCase() }
        })
      }
    },
    deletedSheduledTableCalendar () {
      const filteredSelection = this.multipleSelection.filter((event) => event.status === 'postPlanned')
      const refsSelection = filteredSelection.map((event) => event.reference).filter((value, index, array) => array.indexOf(value) === index)
      const refsUniquesSelection = refsSelection.filter((value, index, array) => array.indexOf(value) === index)

      this.$confirm(
        $t('general.calendar.areYouSureYouWantToDeleteYoursScheduleSelected', { refsUniquesSelection: refsUniquesSelection }),
        $t('general.calendar.deletionPost'),
        {
          confirmButtonText: $t('general.calendar.acceptedPost'),
          cancelButtonText: $t('general.calendar.refusedPost'),
          type: 'warning'
        }
      ).then(() => {
        try {
          for (const event of filteredSelection) {
            this.$store.dispatch('calendarSocialPosts/deleteScheduled', [event])
          }
          this.$store.dispatch('calendarSocialPosts/loadEventsForOneDayByTypePost', { date: this.$route.params.date })
          this.$message({
            type: 'success',
            message: $t('general.calendar.deletionHasBeenCompleted')
          })
        } catch (e) {
          this.$message({
            type: 'error',
            message: $t('general.calendar.deletionFailed')
          })
        }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    fetchPage (page) {
      this.currentPage = page
    },
    fetchPageSize (size) {
      this.pageSize = size
      this.currentPage = 1
    }
  }
}
</script>
<style lang="scss" scoped>
.header-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  .forSelection{
    margin-right: 20px;
    color: #00a4bd;
  }
  .date{
    color: #00a4bd;
    font-size: 15px;
  }
}
.el-table .success-row {
  background: #f0f9eb;
}

.box-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}

.link-pagination{
  color: #00a4bd;
  margin-right: 5px;
}

</style>
